// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yASA","title":"styles_title__1dVmy"};